// Tiny pub/sub so every auto-save on the layout tab (parent-type reorder, row
// reorder, expanded-content reorder, edit modal) can drive ONE bottom-centre
// "Saving… / Saved" indicator, plus a payload for the live preview pop.
let listeners = [];
let clearTimer = null;

const emit = (state, payload) => {
  listeners.forEach((fn) => { try { fn(state, payload); } catch (e) { /* noop */ } });
};

export const subscribeSaveState = (fn) => {
  listeners.push(fn);
  return () => { listeners = listeners.filter((l) => l !== fn); };
};

// Wrap a persist promise so the indicator shows "Saving…" then "Saved". The
// optional `preview` payload describes what changed (for the live preview pop).
export const trackSave = (promise, preview) => {
  if (clearTimer) { clearTimeout(clearTimer); clearTimer = null; }
  emit('saving', preview);
  Promise.resolve(promise)
    .then(() => {
      emit('saved', preview);
      clearTimer = setTimeout(() => emit('idle'), 1300);
    })
    .catch(() => { emit('idle'); });
  return promise;
};
